export default __webpack_public_path__ + "static/media/git-commit.9da97926.svg";